export const getGroupsText = (groups) => {
  const group = []
  if (groups && Array.isArray(groups)) {
    groups.reduce((pre, now) => {
      if (now && now) pre.push(now)
      return pre
    }, group)
    return group.join(';')
  }
  return ''
}
